import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetArticleById } from './types';

export const getArticleById = async (
	articleId: number
): Promise<GetArticleById> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/articlebyid?articleId=${articleId}`;

	const response: GetArticleById = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching article by id:', error);
			return null as never;
		});

	return response;
};
